import { Divider } from '@byecode/ui'
import type { FieldProtocol } from '@lighthouse/core'
import type { NodeTypes, UpdateRecordTriggerConfig } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import OutputVariable from '@/containers/FlowDetail/components/OutputVariable'
import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSource } from '@/hooks/useDataSource'

import * as SC from '../../styles'
import { TriggerModeDataSource } from '../components/TriggerModeDataSource'
import { AttentionField } from './AttentionField'

interface UpdateRecordTriggerConfigureProps {
    nodeType: NodeTypes
    onNodeTypeChange: (val: NodeTypes) => void
    onNodeNameChange: (name: string) => void
    value?: UpdateRecordTriggerConfig
    onChange?: (value: UpdateRecordTriggerConfig) => void
}

export const UpdateRecordTriggerConfigure: React.FC<UpdateRecordTriggerConfigureProps> = ({
    nodeType,
    onNodeTypeChange,
    onNodeNameChange,
    value,
    onChange
}) => {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()

    const dataSourceId = value?.dataSourceId || ''

    const dataSource = useDataSource(appId, envId, dataSourceId)

    const outputOptions = useMemo(() => {
        const current: Record<string, FieldProtocol> = dataSource?.schema || {}

        const values = Object.values(current)

        return values.map(item => ({
            id: item.id,
            label: item.name,
            desc: '记录的字段值',
            type: item.innerType
        }))
    }, [dataSource?.schema])

    return (
        <>
            <SC.Container>
                <TriggerModeDataSource
                    nodeType={nodeType}
                    onNodeTypeChange={onNodeTypeChange}
                    onNodeNameChange={onNodeNameChange}
                    value={value}
                    onChange={next => onChange?.(next as UpdateRecordTriggerConfig)}
                />
            </SC.Container>

            {dataSourceId && (
                <>
                    <Divider />
                    <AttentionField
                        dataSourceId={dataSourceId}
                        value={value?.watchedFields || []}
                        onChange={watchedFields =>
                            onChange?.({
                                ...(value as UpdateRecordTriggerConfig),
                                watchedFields
                            })
                        }
                    />
                </>
            )}

            <OutputVariable options={outputOptions} />
        </>
    )
}
